define([
	"dojo/_base/declare",
	"csi/wizard/Widget"
], function (declare, Widget) {

	const ACTION_REPLACE = "Replace";
	const ACTION_APPEND = "Append";

	return declare(Widget, {

		canShowButton: function (/*String*/idAction) {
			if (idAction === ACTION_REPLACE || idAction === ACTION_APPEND) {
				const ac = this.getSourceController();
				const page = this.getSelectedPage();
				const index = this.getIndexOfPage(page);
				const realizedIndex = ac.getWizardRealizedPageIndex(this, index);

				return (realizedIndex === (ac.getWizardNumberOfRealizedPages(this) - 1));
			}

			return this.inherited(arguments);
		}
	});
});